import { render, staticRenderFns } from "./block-redirect.vue?vue&type=template&id=ce173984&scoped=true&"
import script from "./block-redirect.vue?vue&type=script&lang=js&"
export * from "./block-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce173984",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VChip,VIcon})
